// renderers/styledCellRenderer.ts
import Handsontable from 'handsontable';
import { COLORS } from '../config/constants';
import type { Shipment } from '@/features/shipping-table/types';

export interface RendererContext {
  shipmentsMap?: Record<string, Shipment>;
}

export function createStyledCellRenderer(context: RendererContext) {
  return function styledCellRenderer(
    this: any,
    instance: any,
    td: HTMLTableCellElement,
    row: number,
    col: number,
    prop: string | number,
    value: any,
    cellProperties: any,
  ): HTMLTableCellElement {
    (Handsontable.renderers.BaseRenderer as any).apply(this as any, arguments as any);
    const rowData = instance.getDataAtRow(row);
    const shipmentId = rowData[0]; // ID from hidden column
    const shipmentData = context.shipmentsMap ? context.shipmentsMap[shipmentId] : null;

    const hasEvents = (shipmentData?.eventsCount ?? 0) > 0;

    // Gray out cells that DON'T have events
    if (!hasEvents) {
      td.style.backgroundColor = COLORS.noEventsBg;
      td.style.color = COLORS.noEventsText;
    } else {
      // Reset styling for cells with events
      td.style.backgroundColor = '';
      td.style.color = '';
    }

    td.textContent = value || '';
    return td;
  };
}
